/**
 * Controlled スイッチ。design/js/components.jsx:31-37 を移植。
 * aria-pressed で SR にも状態が伝わる。
 */
export interface ToggleProps {
  on: boolean
  onChange?: (next: boolean) => void

  /** ラベル (a11y 用、視覚表示は親側で行う想定) */
  ariaLabel?: string
}

export const Toggle = ({ on, onChange, ariaLabel }: ToggleProps): JSX.Element => (
  <button
    type="button"
    className={`toggle${on ? ' on' : ''}`}
    onClick={() => onChange?.(!on)}
    aria-pressed={on}
    aria-label={ariaLabel}
  />
)
